/* eslint-disable no-console */
import * as Sentry from '@sentry/react';

const environment = import.meta.env.VITE_ENVIRONMENT;
console.log('Sentry is disabled in local environment', environment);
if (environment !== 'LOCAL') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    integrations: [],
    environment: import.meta.env.VITE_ENVIRONMENT,
  });
}
